import {ReactElement} from "react";
import {RendererProps} from "../RendererProps";
import {ensureNotObject, formatBudgetYearAndVersionType} from "../common";
import * as common from "../styles/common.module.scss";

const VALUE_MONTH_VARS: Record<string, string> = {
    "adjM0": "Value Month 1",
    "adjM1": "Value Month 2",
    "adjM2": "Value Month 3",
    "adjM3": "Value Month 4",
    "adjM4": "Value Month 5",
    "adjM5": "Value Month 6",
    "adjM6": "Value Month 7",
    "adjM7": "Value Month 8",
    "adjM8": "Value Month 9",
    "adjM9": "Value Month 10",
    "adjM10": "Value Month 11",
    "adjM11": "Value Month 12"
};
const VALUE_MONTHS = Object.keys(VALUE_MONTH_VARS);

const TYPE_MONTH_VARS: Record<string, string> = {
    "adjTpM0": "Type Month 1",
    "adjTpM1": "Type Month 2",
    "adjTpM2": "Type Month 3",
    "adjTpM3": "Type Month 4",
    "adjTpM4": "Type Month 5",
    "adjTpM5": "Type Month 6",
    "adjTpM6": "Type Month 7",
    "adjTpM7": "Type Month 8",
    "adjTpM8": "Type Month 9",
    "adjTpM9": "Type Month 10",
    "adjTpM10": "Type Month 11",
    "adjTpM11": "Type Month 12"
};
const TYPE_MONTHS = Object.keys(TYPE_MONTH_VARS);

function hasChange(parsedVariables: Record<string, unknown>): boolean {
    return Object.keys(parsedVariables).some(k => !!VALUE_MONTH_VARS[k]);
}

export function RenderSetOriginalRevenueMarketRentAdjustmentsGranular(props: RendererProps): ReactElement {
    const parsedVariables = props.variables;
    if(!hasChange(parsedVariables)) {
        return <div>No change</div>;
    }

    const renderMonths = (parsedVariables: Record<string, unknown>) => {
        const months = [];
        for(let i = 0; i < 12; i++) {
            const valueMonth = VALUE_MONTHS[i];
            const typeMonth = TYPE_MONTHS[i];

            if(!valueMonth || !typeMonth) {
                continue;
            }

            const valueName = VALUE_MONTH_VARS[valueMonth];
            const typeName = TYPE_MONTH_VARS[typeMonth];

            const value = parsedVariables[valueMonth];
            const type = parsedVariables[typeMonth];

            if(value !== undefined && value !== null) {
                months.push(<div key={valueMonth} className={common.section}>
                    <div>{valueName}: {ensureNotObject(value)}</div>
                    <div>{typeName}: {ensureNotObject(type)}</div>
                </div>);
            }
        }
        return months;
    };

    return <div>
        <div className={common.textHeader}>{formatBudgetYearAndVersionType(parsedVariables["budgetYear"], parsedVariables["versionType"])}</div>
        {renderMonths(parsedVariables)}
    </div>;
}